export const OTP_SEND_COOLDOWN_PREFIX = "auth.otp.send.cooldown";
export const OTP_VERIFY_COOLDOWN_PREFIX = "auth.otp.verify.cooldown";

export const normalizeEmail = (email: string): string =>
  email.trim().toLowerCase();

export const getSendCooldownKey = (email: string): string =>
  `${OTP_SEND_COOLDOWN_PREFIX}:${normalizeEmail(email)}`;

export const getVerifyCooldownKey = (
  email: string,
  otpSessionId: string
): string =>
  `${OTP_VERIFY_COOLDOWN_PREFIX}:${normalizeEmail(email)}:${otpSessionId}`;

const parseRetryAfterToSeconds = (retryAfterHeader?: string): number => {
  if (!retryAfterHeader) {
    return 0;
  }

  const asNumber = Number(retryAfterHeader);
  if (Number.isFinite(asNumber) && asNumber > 0) {
    return Math.ceil(asNumber);
  }

  const asDateMs = Date.parse(retryAfterHeader);
  if (!Number.isNaN(asDateMs)) {
    const diffSeconds = Math.ceil((asDateMs - Date.now()) / 1000);
    return Math.max(0, diffSeconds);
  }

  return 0;
};

export const saveCooldownFromRetryAfter = (
  key: string,
  retryAfterHeader?: string,
  fallbackSeconds = 0
): number => {
  const parsedSeconds = parseRetryAfterToSeconds(retryAfterHeader);
  const remainingSeconds =
    parsedSeconds > 0 ? parsedSeconds : Math.max(0, Math.ceil(fallbackSeconds));
  if (remainingSeconds <= 0) {
    return 0;
  }

  const expiresAt = Date.now() + remainingSeconds * 1000;
  localStorage.setItem(key, String(expiresAt));

  return remainingSeconds;
};

export const getCooldownRemainingSeconds = (
  key: string,
  now = Date.now()
): number => {
  const storedExpiresAt = localStorage.getItem(key);
  if (!storedExpiresAt) {
    return 0;
  }

  const expiresAt = Number(storedExpiresAt);
  if (!Number.isFinite(expiresAt)) {
    localStorage.removeItem(key);
    return 0;
  }

  const remainingSeconds = Math.max(0, Math.ceil((expiresAt - now) / 1000));
  if (remainingSeconds === 0) {
    localStorage.removeItem(key);
  }

  return remainingSeconds;
};

export const clearCooldown = (key: string): void => {
  localStorage.removeItem(key);
};
